// Utils
import { appendOpacityValueToColour } from '../../../common/utils/colours';
import { blue, grey } from '../../../common/styles/colours';
export var IconButtonStylePropertiesByVariant = {
    default: function (theme) {
        var _a, _b, _c, _d, _e, _f;
        return ({
            borderColour: (_a = theme.backgroundTransparent) !== null && _a !== void 0 ? _a : 'transparent',
            backgroundColour: (_b = theme.backgroundAccentPrimary) !== null && _b !== void 0 ? _b : blue[600],
            hoverBackgroundColour: (_c = theme.hoverAccent) !== null && _c !== void 0 ? _c : blue[800],
            activeBackgroundColour: (_d = theme.clickedAccent) !== null && _d !== void 0 ? _d : blue[900],
            disabledBackgroundColour: (_e = theme.disabledAccent) !== null && _e !== void 0 ? _e : blue[200],
            contentColour: (_f = theme.backgroundUI) !== null && _f !== void 0 ? _f : grey[0],
            disabledOpacity: 1,
        });
    },
    outlined: function (theme) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        return ({
            borderColour: (_a = theme.borderTertiary) !== null && _a !== void 0 ? _a : grey[800],
            hoverBorderColour: (_b = theme.borderTertiary) !== null && _b !== void 0 ? _b : grey[800],
            activeBorderColour: (_c = theme.borderTertiary) !== null && _c !== void 0 ? _c : grey[800],
            disabledBorderColour: (_d = theme.disabledPrimary) !== null && _d !== void 0 ? _d : grey[400],
            backgroundColour: (_e = theme.backgroundUI) !== null && _e !== void 0 ? _e : grey[900],
            hoverBackgroundColour: (_f = theme.hoverOverlayPrimary) !== null && _f !== void 0 ? _f : grey[50],
            activeBackgroundColour: (_g = theme.clickedOverlay) !== null && _g !== void 0 ? _g : grey[100],
            disabledBackgroundColour: (_h = theme.backgroundTransparent) !== null && _h !== void 0 ? _h : grey[900],
            contentColour: (_j = theme.contentPrimary) !== null && _j !== void 0 ? _j : grey[900],
            hoverContentColour: (_k = theme.contentPrimary) !== null && _k !== void 0 ? _k : grey[900],
            activeContentColour: (_l = theme.contentPrimary) !== null && _l !== void 0 ? _l : grey[900],
            disabledContentColour: (_m = theme.disabledSecondary) !== null && _m !== void 0 ? _m : grey[900],
        });
    },
    ghost: function (theme) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return ({
            borderColour: (_a = theme.backgroundTransparent) !== null && _a !== void 0 ? _a : 'transparent',
            backgroundColour: (_b = theme.backgroundTransparent) !== null && _b !== void 0 ? _b : 'transparent',
            hoverBackgroundColour: (_c = theme.hoverOverlaySecondary) !== null && _c !== void 0 ? _c : appendOpacityValueToColour(grey[900], 10),
            activeBackgroundColour: (_d = theme.clickedOverlay) !== null && _d !== void 0 ? _d : appendOpacityValueToColour(grey[900], 15),
            disabledBackgroundColour: (_e = theme.backgroundTransparent) !== null && _e !== void 0 ? _e : 'transparent',
            contentColour: (_f = theme.contentPrimary) !== null && _f !== void 0 ? _f : grey[900],
            hoverContentColour: (_g = theme.contentPrimary) !== null && _g !== void 0 ? _g : grey[900],
            activeContentColour: (_h = theme.contentPrimary) !== null && _h !== void 0 ? _h : grey[900],
            disabledContentColour: (_j = theme.disabledSecondary) !== null && _j !== void 0 ? _j : grey[900],
        });
    },
};
//# sourceMappingURL=IconButtonStylePropertiesByVariant.js.map